var md5 = require('md5');

const baasicTranslateOverride = msg => {
	// Fallthrough if backend has returned translation key
	if (msg.toUpperCase(msg) === msg && msg.indexOf('.') > -1) return msg;
	// Hashed key for translation
	return 'BAASIC.' + md5(msg);
};

export { baasicTranslateOverride };



// WEBPACK FOOTER //
// ./src/common/constants/baasicTranslate.js